// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page__BE7wd {
  position: relative;
  display: grid;
  grid-template-columns: 100px 1fr 100px;
  grid-template-rows: 60px 1fr 60px;
  height: 100dvh;
  justify-items: center;
  align-items: center;
}

.gutter__MYpZY {
  width: 100%;
  height: 100%;
  background-color: var(--background-grey);
}

.center__naH0U {
  position: relative;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 40px #e9e9e9;
  display: grid;
  grid-template-rows: 1fr 3fr;
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: center;
  overflow-y: auto;
}

.centerBackground__DBSxb {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 33%;
  width: 100%;
  background-color: var(--background-grey);
}

.welcomeText__xLs8f {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.cardContainer__sATd0 {
  display: grid;
  grid-template-columns: 1fr 10vw 1fr;
  justify-items: flex-start;
  align-items: center;
  width: 100%;
  z-index: 1;
  margin-bottom: 20px;
}

.cardContainer__sATd0:first-child {
  justify-self: flex-end;
}

.card__RY7QN {
  box-shadow: 0 0 40px #e9e9e9;
  box-sizing: border-box;
  height: 410px;
  width: 350px;
  background-color: white;
  display: grid;
  grid-template-rows: 164px 69px 29px 3fr;
  padding: 20px;
  justify-items: center;

  --icon-width: 250px;
  --icon-height: auto;
}

.card__RY7QN:hover {
  box-shadow: 0 0 50px #d2e4ec;
}

.card__RY7QN > button {
  width: 100%;
  align-self: center;
  margin-top: 45px;
}

.cardLeft__EUXyl {
  justify-self: flex-end;
}

@media (max-height: 950px) {
  .welcomeText__xLs8f {
    gap: 15px;
  }

  .center__naH0U {
    grid-template-rows: 110px 3fr;
  }

  .centerBackground__DBSxb {
    display: none;
  }
}

@media (max-width: 1150px) {
  .cardContainer__sATd0 {
    grid-template-columns: 1fr 30px 1fr;
  }
}

@media (max-width: 950px) {
  .cardContainer__sATd0 {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 30px 1fr;
    justify-items: center;
  }

  .cardLeft__EUXyl {
    justify-self: center;
  }
  .welcomeText__xLs8f {
    gap: 15px;
  }

  .centerBackground__DBSxb {
    display: none;
  }

  .welcomeText__xLs8f {
    gap: 15px;
    margin-bottom: 15px;
  }

  @media (max-height: 1150px) {
    .center__naH0U {
      grid-template-rows: 110px 3fr;
    }

    .centerBackground__DBSxb {
      display: none;
    }
  }
}

@media (min-width: 950px) and (min-height: 750px) {
  .centerBackground__DBSxb {
    display: inline;
  }

  .cardContainer__sATd0 {
    margin-bottom: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/containers/directory-app/style.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,iCAAiC;EACjC,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,qBAAqB;;EAErB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gCAAgC;IAChC,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;EACA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE;MACE,6BAA6B;IAC/B;;IAEA;MACE,aAAa;IACf;EACF;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".page {\n  position: relative;\n  display: grid;\n  grid-template-columns: 100px 1fr 100px;\n  grid-template-rows: 60px 1fr 60px;\n  height: 100dvh;\n  justify-items: center;\n  align-items: center;\n}\n\n.gutter {\n  width: 100%;\n  height: 100%;\n  background-color: var(--background-grey);\n}\n\n.center {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 0 40px #e9e9e9;\n  display: grid;\n  grid-template-rows: 1fr 3fr;\n  grid-template-columns: 1fr;\n  justify-items: center;\n  align-items: center;\n  overflow-y: auto;\n}\n\n.centerBackground {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 33%;\n  width: 100%;\n  background-color: var(--background-grey);\n}\n\n.welcomeText {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.cardContainer {\n  display: grid;\n  grid-template-columns: 1fr 10vw 1fr;\n  justify-items: flex-start;\n  align-items: center;\n  width: 100%;\n  z-index: 1;\n  margin-bottom: 20px;\n}\n\n.cardContainer:first-child {\n  justify-self: flex-end;\n}\n\n.card {\n  box-shadow: 0 0 40px #e9e9e9;\n  box-sizing: border-box;\n  height: 410px;\n  width: 350px;\n  background-color: white;\n  display: grid;\n  grid-template-rows: 164px 69px 29px 3fr;\n  padding: 20px;\n  justify-items: center;\n\n  --icon-width: 250px;\n  --icon-height: auto;\n}\n\n.card:hover {\n  box-shadow: 0 0 50px #d2e4ec;\n}\n\n.card > button {\n  width: 100%;\n  align-self: center;\n  margin-top: 45px;\n}\n\n.cardLeft {\n  justify-self: flex-end;\n}\n\n@media (max-height: 950px) {\n  .welcomeText {\n    gap: 15px;\n  }\n\n  .center {\n    grid-template-rows: 110px 3fr;\n  }\n\n  .centerBackground {\n    display: none;\n  }\n}\n\n@media (max-width: 1150px) {\n  .cardContainer {\n    grid-template-columns: 1fr 30px 1fr;\n  }\n}\n\n@media (max-width: 950px) {\n  .cardContainer {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr 30px 1fr;\n    justify-items: center;\n  }\n\n  .cardLeft {\n    justify-self: center;\n  }\n  .welcomeText {\n    gap: 15px;\n  }\n\n  .centerBackground {\n    display: none;\n  }\n\n  .welcomeText {\n    gap: 15px;\n    margin-bottom: 15px;\n  }\n\n  @media (max-height: 1150px) {\n    .center {\n      grid-template-rows: 110px 3fr;\n    }\n\n    .centerBackground {\n      display: none;\n    }\n  }\n}\n\n@media (min-width: 950px) and (min-height: 750px) {\n  .centerBackground {\n    display: inline;\n  }\n\n  .cardContainer {\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page__BE7wd`,
	"gutter": `gutter__MYpZY`,
	"center": `center__naH0U`,
	"centerBackground": `centerBackground__DBSxb`,
	"welcomeText": `welcomeText__xLs8f`,
	"cardContainer": `cardContainer__sATd0`,
	"card": `card__RY7QN`,
	"cardLeft": `cardLeft__EUXyl`
};
export default ___CSS_LOADER_EXPORT___;
